var $c42af7093d2ec3f7$exports = {};
$c42af7093d2ec3f7$exports = {
    "Clear search": `Vymaza\u{165} vyh\u{13E}ad\xe1vanie`
};


export {$c42af7093d2ec3f7$exports as default};
//# sourceMappingURL=sk-SK.mjs.map
